import './App.css';
import Index from './Pages/Index';

function App() {
  return (
    <>
      <Index />
    </>
  );
}

export default App;
